import { FC, ReactNode } from 'react';
import { Title1 } from '@fluentui/react-components';
import { useStyles } from './OnboardingStepWrapper.style';

type OnboardingStepWrapperProps = {
  title: string;
  children: ReactNode;
  currentStep: number;
  totalSteps: number;
}

export const OnboardingStepWrapper: FC<OnboardingStepWrapperProps> = ({ 
  title, 
  children,
  currentStep,
  totalSteps 
}) => {
  const styles = useStyles();

  return (
    <div className={styles.container} data-testid="onboarding-step-wrapper">
      <Title1 data-testid="onboarding-step-title">{title}</Title1>
      
        <div className={styles.progressContainer} data-testid="onboarding-progress-container">
          {/* Background track */}
          <div className={styles.progressTrack} data-testid="onboarding-progress-track" />
          {/* Progress bar fill */}
          <div 
            className={styles.progressFill}
            style={{ width: `${((currentStep + 1) / totalSteps) * 100}%` }}
            data-testid="onboarding-progress-bar"
          />
        </div>
      
      {children}
    </div>
  );
};